import {Component} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-adobe-express-cc-apps-blurb',
  standalone: true,
  imports: [
    NgOptimizedImage,
    RouterLink
  ],
  templateUrl: './adobe-express-cc-apps-blurb.component.html',
  styleUrl: './adobe-express-cc-apps-blurb.component.scss'
})
export class AdobeExpressCcAppsBlurbComponent {
  apps = [
    {
      appName: 'Acrobat',
      iconPath: 'acrobat-pro.svg'
    },
    {
      appName: 'Photoshop',
      iconPath: 'photoshop.svg'
    },
    {
      appName: 'Illustrator',
      iconPath: 'illustrator.svg'
    },
    {
      appName: 'Premiere',
      iconPath: 'premiere-pro.svg'
    },
    {
      appName: 'InDesign',
      iconPath: 'indesign.svg'
    },
    {
      appName: 'XD',
      iconPath: 'xd.svg'
    },
    {
      appName: 'AfterEffects',
      iconPath: 'after-effects.svg'
    },
  ];
}
